export var AddressField;
(function (AddressField) {
    AddressField["NAME"] = "name";
    AddressField["ZIP_CODE"] = "zipCode";
    AddressField["ADDRESS"] = "address";
    AddressField["NUMBER"] = "number";
    AddressField["COMPLEMENT"] = "complement";
    AddressField["ADDRESS_LINE_2"] = "addressLine2";
    AddressField["CITY"] = "city";
    AddressField["STATE"] = "state";
    AddressField["COUNTRY"] = "country";
    AddressField["LOCATION_TYPE"] = "locationType";
    AddressField["LOCATION_ID"] = "locationId";
    AddressField["DELIVERY_LOCATION_ID"] = "deliveryLocationId";
})(AddressField || (AddressField = {}));
